'use strict';

intellidealerAppCoreModule.filter('imageFullPath', function (imagePathService) {
  return function (relativePath) {
    return imagePathService.getFullPath(relativePath);
  }
});
